<template>
  <Modal>
    <Modal.Title>Download file</Modal.Title>
    <Modal.Body>
      <div class="mb-3">Are you sure you want to download this file?</div>
      <FileInfo :file="file">Size: {{ file.metadata.size }}</FileInfo>
    </Modal.Body>
    <Modal.Footer>
      <Button variant="stroke" :size="isMobile ? 'lg' : 'md'" @click="close()">
        Cancel
      </Button>
      <Button
        variant="primary"
        :size="isMobile ? 'lg' : 'md'"
        @click="handleClick"
      >
        Download
      </Button>
    </Modal.Footer>
  </Modal>
</template>

<script setup lang="ts">
import { Modal, Button, useModal } from '@dacr/library'
import { openModal, Modals } from '@/shared/dialogs/modals'
import type { File } from '@/shared/graphql/router/graphql'
import FileInfo from '@/features/explorer/components/FileInfo.vue'
import { useDevice } from '@/shared/composables/useDevice'

const { close } = useModal()
const { isMobile } = useDevice()

const props = defineProps<{
  file: File
}>()

const handleClick = () => {
  openModal(Modals.ProcessingDownload, {
    props: { file: props.file },
  })
}
</script>
